import type { CSSProperties, ReactNode } from "react";
import type { Theme, FontPairing } from "@structurify/shared-types";

interface Props {
  children: ReactNode;
  theme: Theme;
  fonts: FontPairing;
  size?: number;
  color?: string;
  style?: CSSProperties;
}

export function MonoLabel({ children, theme, fonts, size = 9, color, style }: Props) {
  return (
    <span
      style={{
        fontFamily: fonts.mono,
        fontSize: size,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: color ?? theme.inkMute,
        fontWeight: 500,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
